import axios from 'axios'
import { Message } from "element-ui";

// create an axios instance
const service = axios.create({
  baseURL: 'https://dlz.cobetter.com/', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 20000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => config
)

// response interceptor
service.interceptors.response.use(
  response => {
      return response.data;
  },
  error => {
    // 对响应错误做些什么
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
)

export default service




// WEBPACK FOOTER //
// ./src/utils/request.js